<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="결과 정보" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline>
                <!-- [S]결재관련 버튼 -->
                <!-- sysApprovalRequestId: 상세조회시 관련 결재요청일련번호 확인 -->
                <!-- popupParam.isApprContent: 결재요청/결재처리 팝업의 component에 해당 페이지 호출시 true -->
                <!-- approvalStatusCd: 결재요청건에 대한 상태코드 -->
                <!-- popupParam.approvalDocType: TODO(결재할문서에서 상세페이지호출시) -->
                <!-- <c-appr-btn 
                  v-if="!popupParam.isApprContent"
                  ref="appr-btn"
                  name="work-permit-appr-btn"
                  :editable="editable"
                  :approvalInfo="approvalInfo"
                  @beforeApprAction="approvalPatrol"
                  @callbackApprAction="approvalPatrolCallback"
                  @requestAfterAction="getDetail"
                /> -->
                <!-- 삭제 -->
                <c-btn
                  v-if="
                    isOld && !disabled && editable && !popupParam.isApprContent
                  "
                  label="LBLREMOVE"
                  icon="delete_forever"
                  @btnClicked="removePlan"
                />
                <!-- 저장 -->
                <c-btn
                  v-show="!disabled && editable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="patrol"
                  :mappingType="saveType"
                  label="LBLSAVE"
                  icon="save"
                  @beforeAction="savePlan"
                  @btnCallback="saveCallback"
                />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-plant
                  required
                  :disabled="disabled"
                  :editable="editable && !isOld"
                  type="edit"
                  name="plantCd"
                  v-model="patrol.plantCd"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-select
                  required
                  type="edit"
                  codeGroupCd="PATROL_TYPE_FST_CD"
                  :disabled="popupParam.typeDisabled"
                  itemText="codeName"
                  itemValue="code"
                  label="상위구분"
                  name="patrolFstCd"
                  v-model="patrol.patrolFstCd"
                >
                </c-select>
              </div>
              <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <c-text
                  required
                  :editable="editable"
                  :disabled="disabled"
                  label="제목"
                  name="patrolName"
                  v-model="patrol.patrolName"
                >
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-select
                  :required="
                    patrol.patrolFstCd === 'PTF0000001' ||
                    patrol.patrolFstCd === 'PTF0000005'
                  "
                  type="edit"
                  codeGroupCd="PATROL_TYPE_SEC_CD"
                  itemText="codeName"
                  itemValue="code"
                  label="하위구분"
                  name="patrolSecCd"
                  v-model="patrol.patrolSecCd"
                >
                </c-select>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-datepicker
                  required
                  :editable="editable"
                  :disabled="disabled"
                  label="추진일정"
                  type="date"
                  name="patrolDate"
                  v-model="patrol.patrolDate"
                  @datachange="datachange"
                >
                </c-datepicker>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-dept
                  required
                  :editable="editable"
                  :disabled="disabled"
                  label="추진부서"
                  name="deptCd"
                  v-model="patrol.deptCd"
                  @setDeptName="(val) => setDeptName(val, 1)"
                  @datachange="datachange"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-dept
                  :editable="editable"
                  :disabled="disabled"
                  label="주관부서"
                  name="hostDept"
                  v-model="patrol.hostDept"
                  @setDeptName="(val) => setDeptName(val, 2)"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                <!-- 관련공사 -->
                <c-construnction
                  :editable="editable"
                  :disabled="disabled"
                  name="sopConstructionId"
                  v-model="patrol.sopConstructionId"
                >
                </c-construnction>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <c-textarea
                  :editable="editable"
                  :disabled="disabled"
                  label="비고"
                  name="remark"
                  v-model="patrol.remark"
                >
                </c-textarea>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <!-- gridHeight="430px" -->
          <c-table
            ref="grid"
            title="지적사항 및 개선목록"
            :columns="grid.columns"
            :data="grid.data"
            :editable="false"
            :changeData="changeData"
            :gridHeight="gridHeight"
            :usePaging="false"
            :filtering="false"
            :columnSetting="false"
            @linkClick="
              (row, col, idx) =>
                linkClick(row, row.ibmClassCd, row.sopImprovementId)
            "
          >
            <template slot="suffixTitle">
              <font
                v-if="!isOld"
                class="text-negative"
                style="font-size: 0.8em; font-weight: 300"
              >
                ※ 먼저 신규 저장을 하세요.
              </font>
            </template>
            <template slot="table-button">
              <q-btn-group outline>
                <c-btn
                  v-if="!disabled && isOld"
                  label="개선요청"
                  icon="add"
                  color="red-6"
                  @btnClicked="addImpr"
                />
                <c-btn
                  v-if="!disabled && isOld"
                  label="즉시조치"
                  color="light-blue"
                  icon="add"
                  @btnClicked="addImmImpr"
                />
              </q-btn-group>
            </template>
          </c-table>
        </div>
      </div>
    </q-form>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "patrol-detail",
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        saiPatrolId: "",
        patrolFstCd: null,
        typeDisabled: false,
        isApprContent: false,
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: function () {
        return "auto";
      },
    },
  },
  data() {
    return {
      patrol: {
        saiPatrolId: "",
        plantCd: "",
        deptCd: "",
        deptName: "",
        hostDept: "",
        hostDeptName: "",
        patrolFstCd: null,
        patrolSecCd: null,
        patrolDate: "",
        patrolName: "",
        approvalStatusCd: "", // 결재관련 결재상태
        sysApprovalRequestId: "", // 결재관련 결재요청코드
        sopConstructionId: "",
        remark: "",
        regUserId: "",
        chgUserId: "",
        patrolImproveModelList: [],
      },
      grid: {
        columns: [
          {
            name: "ibmTitle",
            field: "ibmTitle",
            label: "지적사항 (개선제목)",
            align: "left",
            type: "link",
            style: "width:200px",
            sortable: false,
          },
          {
            name: "ibmStepName",
            field: "ibmStepName",
            label: "LBLPROGRESS",
            align: "center",
            style: "width:80px",
            sortable: false,
          },
          {
            name: "beforeImprPath",
            field: "beforeImprPath",
            label: "지적사진 (개선 전 사진)",
            align: "center",
            type: "attach",
            customSize: "width: 200px !important;height: 200px !important",
            taskClassCd: "IBM_BEFORE",
            keyText: "sopImprovementId",
            style: "width:200px",
            sortable: false,
          },
          {
            name: "improveRequest",
            field: "improveRequest",
            label: "요청부서/이름/일자",
            align: "center",
            style: "width:120px",
            sortable: false,
          },
          {
            name: "ibmClassName",
            field: "ibmClassName",
            label: "구분",
            align: "center",
            style: "width:60px",
            sortable: false,
          },
          {
            name: "actionContents",
            field: "actionContents",
            label: "조치내용 (요청내용)",
            align: "left",
            style: "width:200px",
            sortable: false,
          },
          {
            name: "afterImprPath",
            field: "afterImprPath",
            label: "개선 후 사진",
            align: "center",
            type: "attach",
            taskClassCd: "IBM_AFTER",
            customSize: "width: 200px !important;height: 200px !important",
            keyText: "sopImprovementId",
            style: "width:100px",
            sortable: false,
          },
          {
            name: "actionCompleteRequestDate",
            field: "actionCompleteRequestDate",
            label: "조치완료 요청일",
            align: "center",
            style: "width:90px",
            sortable: false,
          },
          {
            name: "actionCompleteDate",
            field: "actionCompleteDate",
            label: "조치완료일",
            align: "center",
            style: "width:90px",
            sortable: true,
          },
          {
            name: "actionDeptName",
            field: "actionDeptName",
            // 조치부서
            label: "LBL0001018",
            align: "center",
            style: "width:90px",
            sortable: false,
          },
          {
            name: "hostDeptName",
            field: "hostDeptName",
            label: "주관부서",
            align: "center",
            style: "width:90px",
            sortable: false,
          },
        ],
        data: [],
        height: "",
      },
      editable: true,
      saveType: "POST",
      saveUrl: "",
      deleteUrl: "",
      approvalUrl: "",
      isSave: false,
      isApproval: false,
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        width: "90%",
        param: {},
        closeCallback: null,
      },
      changeData: false,
      ibmTaskTypeCd: null,
      ibmTaskUnderTypeCd: null
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  watch: {
    'patrol.patrolFstCd': {
      immediate: true,
      handler(newVal) {
        if (!newVal)  return;
        this.$comm
          .getComboItems("IBM_TASK_TYPE_CD")
          .then((_result) => {
            const matchType = _result.filter(item => item.attrVal2 === newVal)[0];
            if (matchType) {
            this.ibmTaskTypeCd = matchType.code
              this.$comm
                .getComboItems("IBM_TASK_UNDER_TYPE_CD")
                .then((_result) => {
                  const matchUnderType = _result.filter(item => item.attrVal1 === this.ibmTaskTypeCd && item.useFlag === 'Y')[0];
                  if (matchUnderType) {
                    this.ibmTaskUnderTypeCd = matchUnderType.code;
                  } else this.ibmTaskUnderTypeCd = null;
                  this.getImprList();
                });
            } else {
              this.ibmTaskTypeCd = null;
              this.ibmTaskUnderTypeCd = null;
            }
          });
      }
    }
  },
  computed: {
    gridHeight() {
      return String(this.contentHeight - 250) + "px";
    },
    isOld() {
      return Boolean(this.popupParam.saiPatrolId);
    },
    disabled() {
      return (
        this.patrol.patrolCompleteFlag === "Y" ||
        // 결재중인 경우 비활성화
        (this.patrol.approvalStatusCd === "ASC0000001" &&
          !this.popupParam.isApprContent)
      );
    },
    imprTabInfo() {
      return {
        key: this.popupParam.saiPatrolId,
        ibmTaskTypeCd: this.ibmTaskTypeCd,
        ibmTaskUnderTypeCd: this.ibmTaskUnderTypeCd,
        requestContents: this.patrol.patrolName,
      };
    },
    // approvalInfo() {
    //   return {
    //     sysApprovalRequestId: this.patrol.sysApprovalRequestId, // 결재요청번호
    //     /**
    //      * 결재상태코드
    //      * ASC0000001	결재중
    //      * ASC0000002	반려
    //      * ASC9999999	결재완료
    //      */
    //     approvalStatusCd: this.patrol.approvalStatusCd,
    //     apprEditable: this.editable
    //       && this.isOld
    //       && !this.disabled, // 결재버튼 활성화 기준
    //     param: this.patrol, // 결재 param
    //     approvalUrl: this.approvalUrl, // 결재 url
    //     isApproval: this.isApproval, // 결재 submit
    //     approvalTypeCd: 'APTC000019', // 결재유형코드
    //     approvalParamValue: { // 결재상세화면 파라미터
    //       saiPatrolId: this.patrol.saiPatrolId,
    //       isApprContent: true
    //     },
    //     approvalRequestName: this.patrol.patrolName, // 결재요청명 (문서 title)
    //     approvalConnId: this.patrol.saiPatrolId, // 결재연결용 업무일련번호 (문서 key)
    //   }
    // },
    // [E] 결재관련 버튼 컨트롤
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      this.patrol.patrolDate = this.$comm.getToday();
      if (this.popupParam.typeDisabled) {
        this.patrol.patrolFstCd = this.popupParam.patrolFstCd;
      }
      // url setting
      this.detailUrl = selectConfig.sai.patrol.get.url;
      this.saveUrl = transactionConfig.sai.patrol.insert.url;
      this.deleteUrl = transactionConfig.sai.patrol.delete.url;
      this.approvalUrl = transactionConfig.sai.patrol.update.url;
      this.impListUrl = selectConfig.sop.ibm.improve.others.url;
      // code setting
      // list setting
      this.getDetail();
    },
    getDetail() {
      if (this.isOld) {
        this.$http.url = this.$format(
          this.detailUrl,
          this.popupParam.saiPatrolId,
        );
        this.$http.type = "GET";
        this.$http.request((_result) => {
          this.$_.extend(this.patrol, _result.data);
          this.$emit("setRegInfo", _result.data);
          // this.getImprList();
        });
      }
    },
    getImprList() {
      if (this.imprTabInfo.key) {
        this.$http.url = this.impListUrl;
        this.$http.param = {
          ibmTaskTypeCd: this.imprTabInfo.ibmTaskTypeCd,
          ibmTaskUnderTypeCd: this.imprTabInfo.ibmTaskUnderTypeCd,
          relationTableKey: this.imprTabInfo.key,
        };
        this.$http.type = "GET";
        this.$http.request((_result) => {
          this.grid.data = _result.data;
          this.changeData = !this.changeData;
        });
      }
    },
    savePlan() {
      if (this.isOld) {
        this.saveUrl = transactionConfig.sai.patrol.update.url;
        this.saveType = "PUT";
      } else {
        this.saveUrl = transactionConfig.sai.patrol.insert.url;
        this.saveType = "POST";
        // this.patrol.patrolName =
        //   this.patrol.deptName + " " + this.patrol.patrolDate;
      }
      this.$refs["editForm"].validate().then((_result) => {
        if (_result) {
          window.getApp.$emit("CONFIRM", {
            title: "LBLCONFIRM",
            message: "MSGSAVE", // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: "info", // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.patrol.regUserId = this.$store.getters.user.userId;
              this.patrol.chgUserId = this.$store.getters.user.userId;

              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {},
          });
        } else {
          window.getApp.$emit("APP_VALID_ERROR");
        }
      });
    },
    saveCallback(_result) {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      if (!this.isOld) {
        this.$set(this.popupParam, "saiPatrolId", _result.data);
      }
      this.getDetail();
    },
    /* eslint-disable no-unused-vars */
    removePlan() {
      window.getApp.$emit("CONFIRM", {
        title: "LBLCONFIRM",
        message: "MSGREMOVE", // 삭제하시겠습니까?,
        // TODO : 필요시 추가하세요.
        type: "info", // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(
            this.deleteUrl,
            this.popupParam.saiPatrolId,
          );
          this.$http.type = "DELETE";
          this.$http.request((_result) => {
            window.getApp.$emit("APP_REQUEST_SUCCESS");

            this.$emit("closePopup");
          });
        },
        // 취소 callback 함수
        cancelCallback: () => {},
      });
    },
    // approvalPatrol() {
    //   /**
    //    * 유효성 체크
    //    *  1. 점검결과가 하나라도 입력되었는지?
    //    */
    //   let isIng = true;
    //   if (!this.patrol.results || this.patrol.results.length === 0) {
    //     window.getApp.$emit('ALERT', {
    //       title: 'LBLGUIDE', // 안내
    //       message: 'MSG0000750', // 점검결과를 하나 이상 입력하세요.
    //       type: 'warning', // success / info / warning / error
    //     });
    //     isIng = false;
    //   }

    //   if (isIng) {
    //     this.$refs['editForm'].validate().then(_result => {
    //       if (_result) {
    //         window.getApp.$emit('CONFIRM', {
    //           title: 'LBLCONFIRM',
    //           message: '결재요청 하기 전 입력된 값을 저장합니다.\n진행하시겠습니까?',
    //           // TODO : 필요시 추가하세요.
    //           type: 'info', // success / info / warning / error
    //           // 확인 callback 함수
    //           confirmCallback: () => {
    //             this.patrol.regUserId = this.$store.getters.user.userId
    //             this.patrol.chgUserId = this.$store.getters.user.userId
    //             this.isApproval = !this.isApproval
    //           },
    //           // 취소 callback 함수
    //           cancelCallback: () => {
    //           },
    //         });
    //       } else {
    //         window.getApp.$emit('APP_VALID_ERROR');
    //       }
    //     });
    //   }
    // },
    // [S] 결재관련
    // approvalPatrolCallback(result) { // 결재관련 결재요청버튼 callback
    //   this.$refs['appr-btn'].apprRequestPop();
    // },
    // [E]] 결재관련
    /* eslint-disable no-unused-vars */
    addImpr() {
      this.popupOptions.title = "LBLIMPRREQUEST";
      this.popupOptions.param = {
        requestContents: this.imprTabInfo.requestContents,
        relationTableKey: this.imprTabInfo.key,
        ibmTaskTypeCd: this.imprTabInfo.ibmTaskTypeCd,
        ibmTaskUnderTypeCd: this.imprTabInfo.ibmTaskUnderTypeCd,
        hostDept: this.patrol.hostDept
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/sop/ibm/imprDetail.vue"}`);
      this.popupOptions.width = "80%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeAddImprPopup;
    },
    addImmImpr() {
      this.popupOptions.title = "LBLIMMEDIATE";
      this.popupOptions.param = {
        requestContents: this.imprTabInfo.requestContents,
        relationTableKey: this.imprTabInfo.key,
        ibmTaskTypeCd: this.imprTabInfo.ibmTaskTypeCd,
        ibmTaskUnderTypeCd: this.imprTabInfo.ibmTaskUnderTypeCd,
        hostDept: this.patrol.hostDept
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/sop/ibm/imprImmDetail.vue"}`);
      this.popupOptions.width = "80%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeAddImprPopup;
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, ibmClassCd, sopImprovementId) {
      if (ibmClassCd === "IC00000001") {
        this.popupOptions.title = "LBLIMPROVE";
        this.popupOptions.target = () =>
          import(`${"@/pages/sop/ibm/imprDetail.vue"}`);
      } else {
        this.popupOptions.title = "LBLIMMEDIATE";
        this.popupOptions.target = () =>
          import(`${"@/pages/sop/ibm/imprImmDetail.vue"}`);
      }
      this.popupOptions.param = {
        sopImprovementId: sopImprovementId,
      };
      this.popupOptions.width = "80%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeAddImprPopup;
    },
    closeAddImprPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getImprList();
    },
    setDeptName(deptName, num) {
      if (num === 1) this.patrol.deptName = deptName;
      else this.patrol.hostDeptName = deptName;
    },
    datachange() {
      if (!this.patrol.saiPatrolId) {
        this.patrol.patrolName = this.patrol.deptName + " " + this.patrol.patrolDate;
      }
    },
  },
};
</script>
